import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACCESS_TOKEN_KEY, ID_TOKEN_KEY } from '../../../constants';
import { useTry } from '../../../hooks';
import { RestClient } from '../../../lib';
import { ContentBox } from '../../../styles/LoginContainerStyle';
import { WhiteTextField } from '../../../styles/WhiteTextFieldStyle';
import type { ChangeRequired, Success } from '../Login.type';

interface NewPasswordFormData {
  password: string;
  confirmedPassword: string;
}

function NewPasswordForm(props: Omit<ChangeRequired, 'type'>) {
  const { tryReq } = useTry();
  const [data, setData] = useState<NewPasswordFormData>({ confirmedPassword: '', password: '' });
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();

  return (
    <ContentBox>
      <form
        onSubmit={async (e) => {
          e.preventDefault();

          setError('');
          if (data.password !== data.confirmedPassword) {
            setError('パスワードが一致しません');
            return;
          }

          await tryReq(async () => {
            const { idToken, accessToken } = await RestClient.post<Success>('/new-password', {
              ...props,
              password: data.password,
            });
            localStorage.setItem(ID_TOKEN_KEY, idToken);
            localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
            navigate('/environment');
          });
        }}
      >
        <Stack spacing={3}>
          <h2>リセット パスワード</h2>
          <p>初めてログインの場合は、パスワードの変更が必要</p>
          <WhiteTextField
            label="New Password"
            id="newPassword"
            size="small"
            placeholder="大文字・小文字・記号を１文字以上含む"
            focused
            type="password"
            value={data.password}
            onChange={(e) => setData({ ...data, password: e.target.value })}
          />
          <WhiteTextField
            label="Confirm Password"
            id="confirmedPassword"
            size="small"
            focused
            type="password"
            value={data.confirmedPassword}
            onChange={(e) => setData({ ...data, confirmedPassword: e.target.value })}
            error={!!error}
            helperText={error}
          />
          <Button type="submit">Submit</Button>
        </Stack>
      </form>
    </ContentBox>
  );
}

export { NewPasswordForm };
